import React, { Component } from 'react';
import { Row, Col, Button, FormControl, Modal, FormLabel } from 'react-bootstrap';
import ReactTable from 'react-table';
import { request } from '../../constants/constants';
import moment from 'moment';  
import Pagination from '../../components/Pagination/pagination';

class CancelledBookings extends Component {
    constructor(props) {
        super(props);
            this.state = {
                bookings: [],
                currentDeleteId: ''
            };
    }

    componentDidMount() {
        request('GET', '/bookings/get/cancelledBookings', {}, true).then(result => { 
            console.log("0", result)
            this.setState({
                bookings: result.data.data
            })
        })
    }

    handlerRestore = e => {
        const data = {
            id: e.target.value
        }
        request('PATCH', `/bookings/restoreBooking/${e.target.value}`, data, true).then(result => { 
            this.setState({
                isLoading: true
            })
            window.location.href = "/cancelledbookingstable";
        }).catch(err => { 
            console.error(err.response);
            this.setState({
                isLoading: false,
                error: err.response.data,
                errCode: err.response.status
            })
            this.setState({
                showError: this.state.errCode === 400 ? true : false
            })
        })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleUpdateBookingDate = e => {
        const data = { 
            date: this.state.date, 
            bookingId: this.state.currentDeleteId,
            slot: this.state.slot,
            doctorId: this.state.doctorId
        }
        request('PUT', `/bookings/bookingDateUpdate/${e.target.value}`, data, true).then(res => {
            this.setState({
                isLoading: false
            })
            window.location.href = "/patientsbookingtable";
        }).catch(err => {
            console.error(err.response);
            this.setState({
                isLoading: false,
                error: err.response.data,
                errCode: err.response.status,
                errMessage: err.response.data.message
            })
            this.setState({
                errMessage: this.state.errCode === 400 ? this.state.errMessage : ''
            })
        })
    }
    
    //Modal Functions

    hideModal = () => {
        this.setState({ show: false });
    };

    showRestoreModal = (id, date, doctorId, slot) => {
        this.setState({ 
            show: true, 
            currentDeleteId: id, 
            date: date,
            doctorId: doctorId, 
            slot: slot
        });
    }

    hideModalError = () => {
        this.setState({ showError: false})
    }


    render() {
        const columns = [{
            Header: 'Action',
            Cell: row => 
            <React.Fragment>
                <button className="btn btn-dark mr-1 center" onClick={(e) => this.showRestoreModal(`${row.original.ID}`, `${row.original.date}`, `${row.original.doctors.id}`, `${row.original.slot}`)} >Rebook</button>
            </React.Fragment>,
            width: 105,
            style: { 'whiteSpace': 'unset' },
            className: 'center',
            accessor: 'id'
        },{
            Header: 'Patient Name',
            Cell: row => (<span> {row.original.patients && row.original.patients.title  + '. ' + row.original.patients.first_name + ' ' + row.original.patients.second_name + ' ' + row.original.patients.last_name} </span> ),
            width: 200,
            id: row => row.doctors && row.patients.id,
            accessor: row => row.doctors && row.patients.first_name
        },{
            Header: 'Doctor',
            Cell: row => (<span> {row.original.doctors && row.original.doctors.title + '. ' + row.original.doctors.first_name + ' ' + row.original.doctors.last_name} </span>),
            width: 200,
            id: row => row.doctors && row.doctors.id,
            accessor: row => row.doctors && row.doctors.first_name
        },{
            Header: 'Hospital',
            Cell: row => (<span> {row.original.hospitals && row.original.hospitals.name} </span>),
            width: 250,
            id: row => row.doctors && row.hospitals.id,
            accessor: row => row.doctors && row.hospitals.name
        },
        {
            Header: 'Cancellation Reason',
            Cell: row => (<span> {row.original.cancellation_reason} </span>),
            width: 250,
            accessor: 'cancellation_reason'
        },
        {
            Header: 'Date & Time',
            Cell: row => (<span> {row.original.slot}, {moment(row.original.date).format("DD-MMMM-YYYY")} </span>),
            width: 200,
            accessor: 'date'
        }]

        return (
            <div class="container-fluid cancelled-bookings">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <Row>
                            <Col><h6 className="m-0 font-weight-bold text-primary">Cancelled Bookings</h6></Col>
                        </Row>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">

                            {/* Modal for ERROR  */}
                            <Modal show={this.state.showError}>
                                <Modal.Header onClick={this.hideModalError} closeButton>
                                    <Modal.Title><h5 className="m-0 font-weight-bold text-danger">Slot of the day already taken.</h5></Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="center">
                                        <Col lg={4}><FormLabel>Change Booking Date: </FormLabel></Col>
                                        <Col sm={6}>
                                            <FormControl
                                                type="date"
                                                className="center"
                                                name="date"
                                                value={this.state.date}
                                                onChange={this.handleChange}
                                            />
                                        </Col>      
                                    </Row>  
                                    <br /> 
                                    <Row className="center">
                                        <Col lg={4}><FormLabel>Change Booking Slot: </FormLabel></Col>
                                        <Col sm={6}>
                                            <FormControl
                                                as="select"
                                                name="slot"
                                                className="center"
                                                value={this.state.slot}
                                                onChange={this.handleChange}
                                            >
                                                <option value="-Select-">-Select-</option>
                                                <option value="AM">AM</option>
                                                <option value="PM">PM</option>                                            
                                            </FormControl>
                                        </Col>
                                    </Row> 
                                    <p className="m-0 text-danger center">{this.state.errMessage}</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="btn btn-secondary center" onClick={this.hideModalError}>
                                        Cancel
                                    </button>
                                    <button className="btn btn-primary center" value={this.state.currentDeleteId} onClick={this.handleUpdateBookingDate}>
                                        Rebook
                                    </button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal for Delete Booking  */}
                            <Modal show={this.state.show} backdrop="static" onClick={this.hideModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title><h5 className="m-0 font-weight-bold text-danger">Confirmation:</h5></Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                <p className="text-align" style={{textAlign: 'center'}}>Are you sure you want to rebook this record? </p>
                                   
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.hideModal}>
                                        Cancel
                                    </Button>
                                    <Button 
                                        className="btn btn-danger" 
                                        value={this.state.currentDeleteId} 
                                        onClick={this.handlerRestore}
                                    >Rebook
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <ReactTable
                                className="center"
                                PaginationComponent={Pagination}
                                data={this.state.bookings}
                                columns={columns}
                                defaultExpanded={true}
                                minRows={10}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CancelledBookings;